/**
 * Calculate delivery price based on package weights
 * - Regular items (IDs 1, 2, 3): CHARGED delivery
 * - Combo packs (IDs 4, 5): FREE delivery (included in price)
 * - Pricing: Up to 2kg = Rs 400, then Rs 100 per additional 1kg
 */

// Regular item IDs (charged delivery)
const REGULAR_ITEM_IDS = [1, 2, 3, 6];

// Package weights in kg (based on product sizes)
const PACKAGE_WEIGHTS = {
  1: 0.2,  // 200g - CHARGED
  2: 0.5,  // 500g - CHARGED
  3: 1,    // 1kg - CHARGED
  4: 0.5,  // Combo Small - FREE
  5: 1,    // Combo Medium - FREE
  6: 0,    // Corn Flakes - CHARGED
};

export const calculateDeliveryPrice = (cartItems) => {
  if (!cartItems || cartItems.length === 0) {
    return 0;
  }

  // Check if cart contains any regular items (that need delivery charge)
  const hasRegularItems = cartItems.some(item => REGULAR_ITEM_IDS.includes(item.id));
  
  if (!hasRegularItems) {
    // Only combo packs = no delivery charge (free delivery included)
    return 0;
  }

  // Calculate total weight for REGULAR ITEMS ONLY (charged items)
  const totalWeight = cartItems.reduce((sum, item) => {
    if (REGULAR_ITEM_IDS.includes(item.id)) {
      const weight = PACKAGE_WEIGHTS[item.id] || 0;
      return sum + (weight * item.quantity);
    }
    return sum;
  }, 0);

  // Delivery pricing: Up to 2kg = Rs 400, then Rs 100 per additional 1kg
  if (totalWeight <= 2) {
    return 400;
  } else {
    const additionalWeight = totalWeight - 2;
    const additionalKgs = Math.ceil(additionalWeight);
    return 400 + (additionalKgs * 100);
  }
};

export const getDeliveryPricingRules = () => {
  return {
    basePrice: 400,
    baseWeight: 2,
    additionalPricePerKg: 100,
    description: 'Delivery charges for regular items only: Up to 2kg Rs 400, then Rs 100 per 1kg additional. Combo packs include FREE delivery.',
    comboFreeDelivery: true,
  };
};
